/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { useState, Fragment } from 'react';
import { KeywordSearch, Button } from 'components';
import qs from 'qs';
import { AnimatePresence, motion } from 'framer-motion';
import { useWindowSize } from 'hooks';
import styled, { css } from 'styled-components';
import { DownArrow } from 'assets/svgs';

const convertCamelCaseToTitleCase = (filterCategory) =>
  filterCategory
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();

function ProductFilters({
  className,
  filterCategories,
  filterValues,
  setFilterValues,
  handleFilterClick,
  handleSearchInput,
  searchQuery,
  openedInDialog,
  handleProductFiltersDialog
}) {
  const { windowWidth } = useWindowSize();

  // useEffect(() => {
  //   const queryString = window.location.search?.split('?')[1];
  //   if (queryString) {
  //     const _paramFilterValues = qs.parse(queryString);
  //     const _filterValues = Object.entries(filterValues).reduce((acc, [filterTitle, nestedObj]) => {
  //       acc[filterTitle] = Object.entries(nestedObj).reduce((_acc, [prop]) => {
  //         if (_paramFilterValues[filterTitle]) {
  //           if (_paramFilterValues[filterTitle][prop] === 'true') {
  //             _acc[prop] = true;
  //           } else {
  //             _acc[prop] = false;
  //           }
  //         } else {
  //           _acc[prop] = false;
  //         }
  //         return _acc;
  //       }, {});
  //       return acc;
  //     }, {});

  //     setFilterValues(_filterValues);
  //   }
  // }, []);

  const getFilterCategoryJSX = (filterCategory) => {
    const [seeMore, setSeeMore] = useState(false);
    const [showAll, setShowAll] = useState(false);

    const arr = Object.keys(filterValues[filterCategory])
      .filter((filter) => filter && filter !== '0')
      .map((filter) => (
        <Label key={filter}>
          <HiddenDefaultCheckbox
            name={filter}
            onChange={(e) => handleFilterClick({ e, filterCategory })}
            type="checkbox"
            checked={filterValues[filterCategory][filter]}
          />
          <CustomCheckbox>
            <Filter>{filter}</Filter>
          </CustomCheckbox>
          <Amount>
            {
              filterCategories
                .map((obj) => obj[filterCategory])
                .filter((filters) => filters.includes(filter)).length
            }
          </Amount>
        </Label>
      ));

    if (arr.length) {
      return (
        <Fragment key={filterCategory}>
          <FilterCategoryTitle
            onClick={() => openedInDialog && setShowAll((currentValue) => !currentValue)}
            onKeyDown={(e) => {
              if (openedInDialog && ['Space', 'Enter'].includes(e.code)) {
                setShowAll((currentValue) => !currentValue);
              }
            }}
            role="button"
            tabIndex={openedInDialog ? 0 : -1}>
            <h2>
              {convertCamelCaseToTitleCase(filterCategory)}
              {openedInDialog ? '' : ':'}
            </h2>
            {openedInDialog && (
              <AnimatePresence mode="popLayout">
                {showAll ? <FilterCategoryExpandedIcon /> : <StyledDownArrow />}
              </AnimatePresence>
            )}
          </FilterCategoryTitle>
          <FiltersWrapper
            openedInDialog={openedInDialog}
            custom={{ arrLength: arr.length, seeMore, showAll, openedInDialog }}>
            <Filters
              custom={{ arrLength: arr.length, windowWidth, seeMore, showAll, openedInDialog }}
              openedInDialog={openedInDialog}
              arrLength={arr.length}>
              {arr.sort((a, b) => {
                if (a.key.toLowerCase() < b.key.toLowerCase()) return -1;
                if (a.key.toLowerCase() > b.key.toLowerCase()) return 1;
                return 0;
              })}
            </Filters>
            {arr.length > 7 && !openedInDialog && (
              <SeeMore seeMore={seeMore}>
                <button type="button" onClick={() => setSeeMore((currentValue) => !currentValue)}>
                  <SeeMoreArrowIcon custom={seeMore}>&#9660;</SeeMoreArrowIcon>
                  <span>{seeMore ? 'See Less' : 'See More'}</span>
                </button>
              </SeeMore>
            )}
          </FiltersWrapper>
        </Fragment>
      );
    }
  };

  return (
    <Wrapper className={className} openedInDialog={openedInDialog}>
      <h3>Search by keyword:</h3>
      <KeywordSearch searchQuery={searchQuery} handleSearchInput={handleSearchInput} />
      <h3>Filter by:</h3>
      {Object.keys(filterCategories[0]).map((filterCategory) =>
        getFilterCategoryJSX(filterCategory)
      )}
      {openedInDialog && (
        <Button
          onClick={() => handleProductFiltersDialog({ animation: 'close' })}
          style={{ alignSelf: 'center', marginTop: '30px !important' }}>
          View Selected Products
        </Button>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.aside`
  background-color: #fff;
  border: ${({ openedInDialog }) => !openedInDialog && '0.063rem solid var(--connolly-red)'};
  border-radius: 0.625rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  grid-column: 1/-1;
  max-width: 21.25rem;
  padding: ${({ openedInDialog }) =>
    openedInDialog ? '36px 28px 30px 20px' : '2.1rem 1.125rem 0.125rem'};
  width: 100%;
  z-index: 2;

  @media (width >= 768px) {
    margin-bottom: 100px;
    max-width: unset;
    grid-column: 1/4;
  }

  @media (width >= 1000px) {
    padding: 2.1rem 1.688rem 0.125rem;
  }

  h2 {
    cursor: ${({ openedInDialog }) => (openedInDialog ? 'pointer' : 'default')};
    font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
    flex-grow: 1;
    font-size: ${({ openedInDialog }) => (openedInDialog ? '1.25rem' : '1rem')};
    font-weight: 400;
    padding: ${({ openedInDialog }) => (openedInDialog ? '0.75rem 0 0.75rem 0.5rem' : 0)};

    @media (width >= 48rem) {
      font-size: 1.25rem;
    }
  }

  h3 {
    font-size: 1.25rem;
    padding-left: 0.45em;

    /* 'Search by keyword:' */
    &:nth-of-type(1) {
      margin-bottom: 0.25em;
    }

    /* 'Filter by:' */
    &:nth-of-type(2) {
      margin: 0.1em 0 0.125em;
    }

    @media (width >= 768px) {
      padding-left: initial;

      &:nth-of-type(2) {
        margin: 0.1em 0 0.7em;
      }
    }
  }
`;

const FilterCategoryTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const FilterCategoryExpandedIcon = styled(motion.div).attrs({
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
})`
  background-color: var(--connolly-red);
  border-radius: 50%;
  cursor: pointer;
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

const StyledDownArrow = styled(DownArrow).attrs({
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
})`
  cursor: pointer;
  width: 1rem;

  path {
    fill: var(--connolly-red);
  }
`;

const filterAnimationSpeed = 0.025;

const FiltersWrapper = styled(motion.div).attrs({
  animate: ({ arrLength, seeMore, showAll, openedInDialog }) =>
    showAll || seeMore
      ? {
          paddingBottom: '2.2rem',
          transition: {
            duration: arrLength * filterAnimationSpeed
          }
        }
      : {
          paddingBottom: openedInDialog ? 0 : '1.4rem',
          transition: {
            duration: arrLength * filterAnimationSpeed
          }
        }
})`
  border-bottom: ${({ openedInDialog }) =>
    openedInDialog ? '0.063rem solid var(--connolly-red)' : 0};
  margin-bottom: 0;
  position: relative;

  @media (width >= 768px) {
    &:not(:last-of-type) {
      border-bottom: 0.063rem solid var(--connolly-red);
      margin-bottom: 1.75rem;
    }
  }
`;

const Filters = styled(motion.div).attrs({
  animate: ({ arrLength, windowWidth, showAll, seeMore, openedInDialog }) =>
    showAll || seeMore
      ? {
          height: 'auto',
          transition: {
            duration: arrLength * filterAnimationSpeed
          },
          transitionEnd: {
            overflow: 'visible'
          }
        }
      : {
          height:
            openedInDialog && !showAll
              ? 0
              : arrLength > 7 && windowWidth < 768
                ? '15rem'
                : arrLength > 7 && windowWidth >= 768
                  ? '17.5rem'
                  : 'auto',
          overflow: arrLength > 7 || openedInDialog ? 'hidden' : 'visible',
          transition: {
            duration: arrLength * filterAnimationSpeed
          }
        }
})`
  height: 0;

  ${({ arrLength, openedInDialog }) =>
    arrLength <= 7 &&
    !openedInDialog &&
    css`
      margin-bottom: 0.8rem;
    `};
`;

const Label = styled.label`
  color: var(--connolly-black);
  display: inline-block;
  font-size: 0.875rem;
  letter-spacing: 0.01em;
  line-height: 1.375em;
  margin: 1em 0;
  padding-left: 0.625rem;
  position: relative;
  transition: background-color 0.1s ease-in-out;
  user-select: none;
  width: 100%;

  @media (width >= 48rem) {
    margin: 1.2em 0;
    line-height: 1.375em;
    padding-left: initial;
  }

  & input + span {
    background-color: #fff;
  }

  & input:checked + span {
    border: 0.063rem solid var(--connolly-red);
    background-color: var(--connolly-red);
  }

  & input:checked + span::after {
    display: block;
  }
`;

const HiddenDefaultCheckbox = styled.input`
  cursor: pointer;
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
`;

const CustomCheckbox = styled.span`
  background-color: rgb(238 238 238 / 35%);
  border: 0.063rem solid var(--connolly-black);
  border-radius: 0.125rem;
  cursor: pointer;
  height: 1.25rem;
  position: absolute;
  transition:
    background-color 0.1s ease-in-out,
    border-color 0.1s ease-in-out;
  width: 1.25rem;

  &::after {
    border-color: #fff;
    border-style: solid;
    border-width: 0 0.155rem 0.155rem 0;
    content: '';
    display: none;
    height: 0.675rem;
    left: 0.425rem;
    position: absolute;
    top: 0.15rem;
    transform: rotate(39deg);
    width: 0.35rem;
  }
`;

const Filter = styled.span`
  left: 2.125em;
  letter-spacing: 0.02em;
  position: absolute;
  white-space: nowrap;

  @media (width >= 48rem) {
    font-size: 1rem;
    top: 0.05em;
  }
`;

const Amount = styled.span`
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0.063em;

  @media (width >= 48rem) {
    font-size: 1rem;
    top: 0.125em;
  }
`;

const SeeMore = styled(motion.div)`
  align-items: end;
  background: ${({ seeMore }) => (seeMore ? 'transparent' : 'linear-gradient(transparent, #fff)')};
  bottom: 0;
  display: flex;
  font-size: 0.875rem;
  height: 7.188em;
  justify-content: center;
  margin: 0 auto;
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 1;

  @media (width >= 48rem) {
    font-size: 1rem;
  }

  button {
    background-color: transparent;
    border: none;
    color: var(--connolly-red);
    cursor: pointer;
    font-size: 0.775rem;
    padding: 0.875em 0.875em 0.722em;
    pointer-events: auto;
    width: 7.825em;

    @media (width >= 48rem) {
      font-size: 0.875rem;
    }

    span:first-of-type {
      color: var(--connolly-red);
      display: inline-block;
      top: 0.063em;
      margin-right: 0.1875em;
      position: relative;
    }

    span:last-of-type {
      color: var(--connolly-red);
      font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
      font-weight: 600;
      margin-top: 0.125em;
      text-decoration: underline;
    }
  }
`;

const SeeMoreArrowIcon = styled(motion.span).attrs({
  animate: (seeMore) =>
    seeMore
      ? {
          rotate: -180
        }
      : {
          rotate: 0
        }
})``;

export default ProductFilters;
